import React, { useState, useEffect } from "react";
import cx from "classnames";

import Input from "../../forms/Input";
import Button from "../Button";
import SuccessModal from "containers/MealPlan/components/SuccessModal";

type Props = {
  onSave: (name: string) => void;
  close: () => void;
  currentName: string;
  visible: boolean;
  isCustomPlan?: boolean;
  confirmRequired?: boolean;
  isConfirmed?: boolean;
  isCreatePlan?: boolean;
  error?: string;
  classNames?: {
    title?: string;
  };
  setError?: React.Dispatch<React.SetStateAction<string>>;
  closeSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  visibleSuccess: boolean;
};

const SavePlanModal = (props: Props) => {
  const {
    close,
    currentName,
    isCreatePlan = false,
    isCustomPlan = false,
    onSave,
    visible,
    confirmRequired,
    error,
    setError,
    classNames,
    closeSuccess,
    visibleSuccess,
  } = props;

  const [name, setName] = useState("");
  const [onClickSave, setOnClickSave] = useState(false);

  const closeHandler = () => {
    close();
    setError("");
  };

  useEffect(() => {
    setName(currentName);
  }, [currentName]);
  useEffect(() => {
    if (visible) {
      setOnClickSave(false);
    }
  }, [visible]);
  const changeName = (e) => {
    setName(e.target.value);
  };
  const handleSave = () => {
    if (!confirmRequired) {
      closeHandler();
    } else {
      setOnClickSave(true);
    }
    onSave(name);
  };

  return (
    <div className={cx("modal save-plan-modal", { visible })}>
      <div className="scrollable-layer">
        <div className="body">
          {isCreatePlan ? (
            <p className={cx("message", classNames?.title ?? "")}>
              What would you like to name this plan?
            </p>
          ) : (
            <></>
          )}
          <Input
            placeholder="Plan name"
            value={name}
            onChange={changeName}
            error={error}
          />
          <div className="footer-buttons">
            <Button small onClick={closeHandler}>
              Close
            </Button>
            <Button
              disabled={!name || (confirmRequired && onClickSave)}
              primary
              small
              onClick={handleSave}
            >
              {isCustomPlan ? "Update" : "Save"}
            </Button>
          </div>
        </div>
      </div>
      <SuccessModal
        close={closeSuccess}
        visible={visibleSuccess}
      >
        <p className="message">
          The Meal plan has been {isCustomPlan ? "updated" : "saved"}
          successfully!
        </p>
      </SuccessModal>
    </div>
  );
};

export default SavePlanModal;
